module.exports = __webpack_public_path__ + "static/media/eyeslash.a81b2719.svg";